<template>
  <div class="root">
    <div class="head">
      <div class="enterprise-logo">
        <img v-if="bgUrl" class="logo" :src="bgUrl" />
      </div>
    </div>
    <div class="body">
      <div class="list">
        <div class="list_item" v-for="(item, index) in permissionsInfo" :key="index">
          <div
            class="common"
            :style="{
              backgroundColor: backgroundColor[index % backgroundColor.length],
              color: color[index % color.length],
            }"
            @click="handleClick(item)">
            <div class="rectangle">
              <div class="all-icon" :style="{ color: color[index % color.length] }">
                <svg-icon :icon-class="item.icon"></svg-icon>
              </div>
              <div class="title">
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { indexConfig } from '@/api/auth'
export default {
  data () {
    return {
      backgroundColor: [
        '#bad6fd',
        '#fee2ab',
        '#b5e5f6',
        '#becbf5',
        '#a8e8d3',
        '#f5efbe',
        '#fddee3'
      ],
      color: [
        '#4371ae',
        '#9f7629',
        '#4390ab',
        '#435cae',
        '#29a079',
        '#afa231',
        '#e36d80'
      ],
      bgUrl: ''
    }
  },
  mounted () {
    setTimeout(() => {
      if (this.permissionsInfo.length === 1) {
        this.$router.push({ path: this.permissionsInfo[0].url })
      } else {
        const params = {
          tenantId: this.userInfo.tenantId,
          ruleTypes: ['mobile_title', 'mobile_home_pic']
        }
        indexConfig(params).then((res) => {
          this.bgUrl = res.data.mobile_home_pic
        })
      }
    }, 200)
  },
  computed: {
    ...mapGetters(['permissionsInfo', 'userInfo'])
  },
  methods: {
    handleClick (item) {
      this.$router.push({ path: item.url })
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === 'visitSuccess' || from.name === 'terminalVisitMap') {
      to.meta.isUseCache = false
      next()
    } else {
      to.meta.isUseCache = true
      next()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (from.meta.isUseCache === false) {
      to.meta.keepAlive = false
      next()
    } else {
      to.meta.keepAlive = true
      next()
    }
  }
}
</script>

<style lang="stylus" scoped>
.root {
  width: 750px;
  height 100%
  background: url('/assets/images/background.png') no-repeat;
  background-size: cover;
  text-align: center;
  overflow: hidden;
    .head {
        width: 100%;
        text-align: center;
        .enterprise-logo {
          margin: 0 auto;
          width: 510px;
          height: 268px;
          padding-top: 100px;
          .logo {
            height: 100%;
            width: 100%;
          }
        }
    }
    .body {
        height: 100%;
    .list {
        width: 560px;
        max-height: calc(100% - 300px)
        padding-top: 20px;
        overflow-y: scroll;
        margin: 20px 95px 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        &_item{
            display: flex;
            margin-bottom: 30px;
            .common {
              display:flex;
              flex: 1;
              height: 230px;
              margin: auto;
              text-align: center;
              box-shadow: 0px 0px 20px 0px rgba(43, 79, 153, 0.2);
              border-radius: 14px;
              .rectangle{
                margin: auto;
                .all-icon {
                  margin: 0 70px;
                  height: 116px;
                  width: 125px;
                    font-size: 80px;
                      .icon {
                        height: 100%;
                        width: 100%;
                      }
                    }
                .title {
                  font-size: 32px;
                  line-height: 60px;
                  margin: 0 45px;
                }
              }
            }
        }
      }
    }
}

</style>
